export const environment = {
    production: true,
    apiUrl: 'http://localhost:5000/api',
    fileUrl: 'http://localhost:5000/',
    testUser: {
      token: {},
      email: '',
    },
  };
  